import React from 'react'
import './spinner.scss'

const Spinner = () => {
  return (
    <div className="loadingio-spinner-eclipse-gzsbpq8et6o">
      <div className="ldio-vc76htzamw">
        <div></div>
      </div>
    </div>
  )
}  

export default Spinner
